import PushNotificationsFeatureImage from '../../assets/images/push-notifications-feature.png';
import React from 'react';
import { ConfirmModal } from '../../commons/components/ConfirmModal';
import { mobileConfig } from '../../commons/config';

export const PushNotificationsDeniedModal = (props: { onClose: () => void }) => {
  const { onClose } = props;
  const isAndroid = mobileConfig().growegyMobilePlatform === 'android';

  return (
    <ConfirmModal
      title="Enable notifications"
      centerTitle={true}
      footer={{
        type: 'show',
        applyButton: {
          label: 'Got it',
          onClick: onClose,
        },
      }}
      onClose={onClose}
    >
      <div className="release-prompt__content-container">
        <img src={PushNotificationsFeatureImage} alt="Push notifications" width={300} />
        <div
          className="d-flex flex-column align-items-center"
          style={{ rowGap: '8px', maxWidth: '400px', margin: '0 auto' }}
        >
          {isAndroid ? (
            <>
              <p className="text-left">
                Push notifications help you never miss an invoice, or an important update. Please
                follow these steps:
              </p>
              <ol className="align-self-start">
                <li>Open your device Settings</li>
                <li>Go to Apps</li>
                <li>Find and tap on Growegy</li>
                <li>Select Notifications</li>
                <li>Toggle notifications ON</li>
              </ol>
            </>
          ) : (
            <>
              <p className="text-center">
                To enable notifications for Growegy, please follow these steps:
              </p>
              <ol className="align-self-start">
                <li>Open your device Settings</li>
                <li>Scroll down and tap on Growegy</li>
                <li>Toggle Allow Notifications ON</li>
              </ol>
            </>
          )}
        </div>
      </div>
    </ConfirmModal>
  );
};
